const AccessibilityConstants = {
    START_PLAY: 'startPLay',
    END_PLAY: 'endPlay',
    PLAY_INDEX_CHANGE: 'playIndexChange',
    MOVE_SELECTED_ELEMENTS_WITH_ARROW: 'moveSelectedElementsWithArrow',
};
export default AccessibilityConstants;

export const PPT_ACCESSIBILITY = 'PPT_ACCESSIBILITY';

export const keyboardActions = {
    PASTE: 'paste',
};

export const EXTRA_DIV_FOR_ACCESSIBILITY = 'extra-div-for-accessibility';
